var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 10C17.6132 10 10 17.6132 10 27C10 29.9415 10.7462 32.7099 12.0655 35.1215L10 44L18.8785 41.9345C21.2901 43.2538 24.0585 44 27 44C36.3868 44 44 36.3868 44 27C44 17.6132 36.3868 10 27 10Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8984 30.8437H24.7298V29.1351C24.7298 28.3889 24.8163 27.8265 25.0001 27.4697C25.1732 27.102 25.5625 26.6262 26.1681 26.0314L28.212 23.9875C28.6445 23.5225 28.8608 22.9385 28.8608 22.2464C28.8608 21.5543 28.6337 20.9811 28.1903 20.5269C27.7361 20.0727 27.163 19.8348 26.4492 19.8348C25.7355 19.8348 25.1515 20.0511 24.6649 20.4945C24.1891 20.9379 23.9079 21.5218 23.8322 22.2464H20.4365C20.6204 20.581 21.2692 19.2833 22.3831 18.3424C23.497 17.4016 24.8812 16.9258 26.5466 16.9258C28.212 16.9258 29.5638 17.38 30.6127 18.2884C31.6617 19.1968 32.1808 20.462 32.1808 22.0842C32.1808 23.2089 31.878 24.1389 31.2616 24.8851C30.9047 25.3285 30.6344 25.6529 30.4505 25.8367C30.2667 26.0206 30.0179 26.2585 29.7043 26.5505C29.3907 26.8424 29.1312 27.0912 28.9149 27.3075C28.6986 27.5237 28.5256 27.7076 28.3958 27.859C28.0606 28.2699 27.8875 28.8539 27.8875 29.6001V30.8437H27.8984ZM26.3735 37.0727C25.7896 37.0727 25.2813 36.8673 24.8487 36.4671C24.4162 36.067 24.1999 35.5804 24.1999 35.0072C24.1999 34.4341 24.4054 33.9474 24.8271 33.5365C25.2489 33.1255 25.7571 32.9201 26.3411 32.9201C26.9251 32.9201 27.4333 33.1255 27.8659 33.5257C28.2985 33.9258 28.504 34.4124 28.504 34.9856C28.504 35.5587 28.2985 36.0454 27.8767 36.4563C27.4658 36.8673 26.9575 37.0727 26.3735 37.0727Z",
    fill: "#AD0101"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.65098 0 0 0 0 0.313726 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.06b0037a.svg";
export { ForwardRef as ReactComponent };